export const convert1DArrayInto2DRows = (arr: any[], rowLength: number) => {
  const rows = []

  for (let i = 0; i < rowLength; i++) {
    const start = i * rowLength
    const end = start + rowLength
    rows.push(arr.slice(start, end))
  }

  return rows
}
